import { ArrowKeyNavigatorDirective } from '@app/shared/arrow-key-navigator.directive';
import { CommaSeparatorDirective } from '@app/shared/comma-separator.directive';
import { CommonModule } from '@angular/common';
import { CtrlKeyListenerDirective } from '@app/shared/ctrl-key-listener.directive';
import { DatepickerHelperDirective } from '@app/shared/datepicker-helper.directive';
import { DivResizeDirective } from '@app/shared/div-resize.directive';
import { FilterPipe } from '@app/shared/filter.pipe';
import { FocusDirective } from '@app/shared/focus.directive';
import { FormsModule } from '@angular/forms';
import { HtmlSafePipe } from '@app/shared/html-safe.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { NgModule } from '@angular/core';
import { NoteComponent } from '@app/shared/note.component';
import { NumberFormatDirective } from '@app/shared/number-format.directive';
import { OkDialogComponent } from '@app/shared/dialogs/ok-dialog.component';
import { OnlyNumberDirective } from '@app/shared/only-number.directive';
import { PhoneNumberMaskDirective } from '@app/shared/phone-number-mask.directive';
import { PrintOptionsDialogComponent } from '@app/shared/dialogs/print-dialog/print-options-dialog.component';
import { ProgressRingComponent } from '@app/shared/progress-ring.component';
import { ProgressSpinnerDirective } from '@app/shared/progress-spinner.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { StatusModalComponent } from '@app/shared/dialogs/status-modal.component';
import { TimeFormatDirective } from '@app/shared/time-format.directive';
import { YesNoDialogComponent } from '@app/shared/dialogs/yes-no-dialog.component';

@NgModule({
  declarations: [
    ArrowKeyNavigatorDirective,
    CommaSeparatorDirective,
    CtrlKeyListenerDirective,
    DatepickerHelperDirective,
    DivResizeDirective,
    FilterPipe,
    FocusDirective,
    HtmlSafePipe,
    NoteComponent,
    NumberFormatDirective,
    OkDialogComponent,
    OnlyNumberDirective,
    PhoneNumberMaskDirective,
    PrintOptionsDialogComponent,
    ProgressRingComponent,
    ProgressSpinnerDirective,
    StatusModalComponent,
    TimeFormatDirective,
    YesNoDialogComponent
  ],
  exports: [
    ArrowKeyNavigatorDirective,
    CommaSeparatorDirective,
    CtrlKeyListenerDirective,
    DatepickerHelperDirective,
    DivResizeDirective,
    FilterPipe,
    FocusDirective,
    HtmlSafePipe,
    NoteComponent,
    PhoneNumberMaskDirective,
    ProgressRingComponent,
    ProgressSpinnerDirective,
    NumberFormatDirective,
    OnlyNumberDirective,
    TimeFormatDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatListModule,
    MatRadioModule,
    MatProgressBarModule,
    MatSelectModule,
    ReactiveFormsModule
  ],
  providers: []
})
export class SharedModule {}
